module.exports = __webpack_public_path__ + "img/icon-del.a308f549.png";